import { finalize, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoadingService } from '../loading.service';
import { Store } from '@ngxs/store';
import { environment } from '@app/core/environments/environment';
import { IBillsProductResponse, IBondsProductResponse, IFixedDepositProductResponse, IPortfolioCashResponse, PortfolioBalancePayload } from '@app/core/models/client/products/products.model';
import { Pagination } from '@app/core/models/client/account/pagination.models';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {
  http = inject(HttpClient);
  loadingService = inject(LoadingService);
  store = inject(Store)

  PORTFOLIO_URL = environment.CLIENT_BASE_URL + '/v1/portfolio';

  constructor() { }

  getPortfolioCash(accountId: string, currency: string): Observable<IPortfolioCashResponse> {
    const uniqueStateUrl = 'get-portfolio-cash';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<IPortfolioCashResponse>(
        `${this.PORTFOLIO_URL}/get-portfolio-cash?account_id=${accountId}&currency=${currency}`
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );

  }
  getPortfolioBalance(payload: PortfolioBalancePayload): Observable<any> {
    const uniqueStateUrl = 'get-portfolio-balance';
    this.loadingService.setLoading(uniqueStateUrl, true);
    return this.http
      .post<any>(
        `${this.PORTFOLIO_URL}/get-portfolio-balance`, payload
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
  getPortfolioStat(accountId: string, currency: string): Observable<any> {
    const uniqueStateUrl = 'get-portfolio-stat';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<any>(
        `${this.PORTFOLIO_URL}/get-portfolio-chart?account_id=${accountId}&currency=${currency}`
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getPortfolioList(accountId: string, currency: string): Observable<any> {
    const uniqueStateUrl = 'get-portfolio-list';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<any>(
        `${this.PORTFOLIO_URL}/get-portfolio-list?account_id=${accountId}&currency=${currency}`
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getCashHistoryList(pagination: Pagination, accountId: string, currency: string): Observable<any> {
    const uniqueStateUrl = 'get-cash-history';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<any>(
        `${this.PORTFOLIO_URL}/get-cash-history?account_id=${accountId}&currency=${currency}&skip=${pagination.skip}&take=${pagination.size }`
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
  
    getCashBalance(payload: PortfolioBalancePayload): Observable<any> {
    const uniqueStateUrl = 'get-cash-balance';
    this.loadingService.setLoading(uniqueStateUrl, true);
    return this.http
      .get<any>(
        `${this.PORTFOLIO_URL}/get-portfolio-cash?account_id=${payload.account_id}&currency=${payload.currency}`,
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
}
